import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import {Link, useNavigate, useParams} from "react-router-dom";
import styled from "styled-components";
import { updateAboutUsHeader, getAboutUsHeader, createAboutUsHeader } from "../../../api/axios";
import CmsCircularProgress from "../../Common/CircularProgress";
import { showToast } from "../../../Utills/toast";
import FormGroup from "../../Common/FormGroup";
import { Formik } from "formik";
import * as Yup from "yup";

// Validation Schema
const validationSchema = Yup.object({
  paragraph: Yup.string()
    .required("Header title is required"),
});

export default function HeaderEdit() {

  const {id, partnerId } = useParams();

  const [isUpdating, setIsUpdating] = useState(false);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [header, setHeader] = useState({
    paragraph: "",
    index: null,
  });

  const getInitialValues = () => ({
    paragraph: header.paragraph || "",
  });

  const fetchHeaderData = async () => {
    setIsLoading(true);
    if (!Number(id)) {
      setIsLoading(false);
      return;
    }

    try {
      const response = await getAboutUsHeader(id);
      const headerData = response.data.data[0];
      setHeader({
        ...headerData,
        index: response.data.data.indexOf(headerData),
      });
      console.log(response.data.data[0].paragraph);
    } catch (error) {
      console.log(error);
      showToast({
        type: 'error',
        message: error?.response?.data?.message || "Failed to fetch header data. Please try again.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchHeaderData();
  }, [id]);

  const createTitle = async (formData) => {
    setIsUpdating(true);
    try {
      const response = await createAboutUsHeader(formData);
      if(response.status === 200){
        showToast({
          type: 'success',
          message: response?.data?.message || "Header section has been created successfully!",
        });
        const headerData = response?.data?.data;
        setHeader(headerData);
        if (headerData && headerData.id) {
          navigate(`/${partnerId}/aboutus/header/edit/${headerData.id}`);
        }
      }else{
        showToast({
          type: 'error',
          message: response?.data?.message || "Failed to create header section. Please try again.",
        });
      }
      console.log(response.data);
    } catch (error) {
      showToast({
        type: 'error',
        message: error?.response?.data?.message || "Failed to create header section. Please try again.",
      });
      console.error(error);
    } finally {
      setIsUpdating(false);
    }
  };

  const updateTitle = async (id, formData) => {
    setIsUpdating(true);
    try {
      const response = await updateAboutUsHeader(id, formData);
      showToast({
        type: 'success',
        message: response?.data?.message || "Header section has been updated successfully!",
      });
      console.log(response.data);
      setHeader(response.data.data);
    } catch (error) {
      showToast({
        type: 'error',
        message: error?.response?.data?.message || "Failed to update header section. Please try again.",
      });
      console.error(error);
    } finally {
      setIsUpdating(false);
    }
  };

  const handleSubmit = async (values) => {
    const formData = {
      paragraph: values.paragraph, 
    };
    
    if (!Number(id)){
      formData.partner_id = partnerId;
      await createTitle(formData);
    } else {
      await updateTitle(id, formData);
    }
  };

  return (
    <>
     {isLoading ? <CmsCircularProgress/> : 
    <FormWrapper>
      <Title>{Number(id) ? 'Edit' : 'Add' } header section</Title>
      <SliderDiv>
        <Formik
          initialValues={getInitialValues()}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          {({
            values,
            errors,
            touched,
            handleSubmit,
            getFieldProps,
            isSubmitting,
          }) => (
            <Form noValidate onSubmit={handleSubmit}>
              <FormGroup 
                label="Enter a New Title" 
                requiredField
                error={touched.paragraph && errors.paragraph ? errors.paragraph : ''}
              >
                <Form.Control
                  type="text"
                  {...getFieldProps('paragraph')}
                  placeholder="Enter header title here..."
                  isInvalid={touched.paragraph && !!errors.paragraph}
                />
              </FormGroup>
              
              <ButtonWrapper className="mt-3">
                <Link
                  to={`/${partnerId}/aboutus/header/view/${Number(id) ? id : 'create'}`}
                  style={{
                    width: "50%",
                  }}
                >
                  <Button variant="secondary">Go Back</Button>
                </Link>
                <Button
                  style={{
                    width: "50%",
                  }}
                  variant="primary"
                  type="submit"
                  disabled={isUpdating || isSubmitting}
                >
                  {isUpdating ? "Saving..." : "Save Changes"}
                </Button>
              </ButtonWrapper>
            </Form>
          )}
        </Formik>
      </SliderDiv>
    </FormWrapper>}
    </>
  );
}

const FormWrapper = styled.div`
  @media (min-width:576px) {
   padding: 1rem;
  }
    @media (min-width:768px) {
   padding: 1.5rem;
  }
   padding: .5rem;
`;

const Title = styled.h3`
  text-align: center;
  padding: 10px 0;
`;

const ButtonWrapper = styled.div`
  margin: 0 auto;
  display: flex;
  gap: 2rem;
  justify-content: center;
  align-items: center;
`;
const SliderDiv = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
`;